/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowexample12Inputs */

const en_aiflowexample12 = /** @type {(inputs: Aiflowexample12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halloween rave at the Tabakfabrik on 31 Oct from 10 pm, dark with neon`)
};

const de_aiflowexample12 = /** @type {(inputs: Aiflowexample12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halloween Rave in der Tabakfabrik am 31.10. ab 22 Uhr, eher düster mit Neon`)
};

/**
* | output |
* | --- |
* | "Halloween rave at the Tabakfabrik on 31 Oct from 10 pm, dark with neon" |
*
* @param {Aiflowexample12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowexample12 = /** @type {((inputs?: Aiflowexample12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowexample12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowexample12(inputs)
	return de_aiflowexample12(inputs)
});
export { aiflowexample12 as "aiFlowExample1" }